import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import fetchStartupsData from "./data"; // Fetch startups from DynamoDB
import {fetchRecentTransactions} from "../RecentTransactions"; // you forgot this import!
import StartupCard from "./StartupCard";
import CreditCard from "../CreditCard";
import InvestedStartups from "./InvestedStartups";
import { addStartup } from "./dynamoOperations"; // Optional for later
import Header from "./Header";
import "./Home.css"; // Your CSS file

const Home = () => {
  // Example invested startups
  const exampleInvestedStartups = [
    {
      id: "tech1",
      name: "TechNova",
      logo: "/path/to/logo",
      description: "AI-powered analytics platform",
      goal: "Transform data into actionable insights",
      invested: 45000,
      stake: 20,
      totalUsers: 1500,
      team: ["John Doe", "Jane Smith"]
    },
    {
      id: "green1",
      name: "GreenFuture",
      logo: "/path/to/logo",
      description: "Sustainable energy solutions",
      goal: "Renewable energy innovation",
      invested: 125000,
      stake: 35,
      totalUsers: 2000,
      team: ["Alice Johnson", "Bob Wilson"]
    }
  ];

  const [transactions, setTransactions] = useState([]);
  const [availableStartups, setAvailableStartups] = useState([]);
  const [investedStartups, setInvestedStartups] = useState(exampleInvestedStartups);
  const [message, setMessage] = useState("");

  useEffect(() => {
    async function loadTransactions() {
      try {
        const fetched = await fetchRecentTransactions();
        setTransactions(fetched);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    }
    loadTransactions();
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await fetchStartupsData();
        setAvailableStartups(data);
      } catch (error) {
        console.error("Error fetching startups data:", error);
        setMessage("Error fetching startups data.");
      }
    }
    fetchData();
  }, []);

  const investInStartup = (id) => {
    const selectedStartup = availableStartups.find(
      (s) => s.id === id || s.startupName === id
    );
    if (selectedStartup) {
      setInvestedStartups((prev) => [...prev, selectedStartup]);
      setAvailableStartups((prev) =>
        prev.filter((s) => s.id !== id && s.startupName !== id)
      );
      setMessage(`Successfully invested in ${selectedStartup.name || selectedStartup.startupName}`);
    }
  };

  return (
    <div className="container">
      <Header />
      <CreditCard transactions={transactions} />

      {message && <p className="success-message">{message}</p>}

      <div className="home-content">
        {/* Left side: Available Startups */}
        <div className="home-column">
          <h2 className="section-title">Available Startups</h2>
          {availableStartups.length > 0 ? (
            availableStartups.map((startup) => (
              <StartupCard
                key={startup.id || startup.startupName}
                logo={startup.logoURL || startup.logo}
                name={startup.startupName || startup.name}
                description={startup.bio || startup.description}
                goal={startup.targetInvestment || startup.goal}
                invested={startup.totalInvested || startup.invested}
                stake={startup.capitalOneStake || startup.stake}
                totalUsers={startup.totalUsersInvesting || startup.totalUsers}
                team={startup.teamMembers || startup.team}
                onInvest={() => investInStartup(startup.id || startup.startupName)}
                investedStatus={false}
              />
            ))
          ) : (
            <p>No more startups available.</p>
          )}
        </div>

        {/* Right side: Investment Portfolio */}
        <div className="home-column">
          <h2 className="section-title">Investment Portfolio Analytics</h2>
          {investedStartups.length > 0 ? (
            <InvestedStartups investedStartups={investedStartups} />
          ) : (
            <p>No investments yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
